import { WithdrawApprovalResponseSchema } from './withdraw-approval.schema';
export const withdrawApprovalContract = {
    method: 'POST',
    path: '/api/v2/approval/:id/withdraw',
    description: 'Withdraw a pending approval as its requester',
    responseSchema: WithdrawApprovalResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Approval is no longer pending',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not the requester',
            404: 'Approval not found'
        }
    }
};

//# sourceMappingURL=withdraw-approval.contract.js.map